module.exports = __webpack_public_path__ + "assets/img/two-tab5-on.c2429367.png";